import _      from 'lodash';
import moment from 'moment';
import Model  from 'alto-orm/lib/orm/model';

class PersonalInfo extends Model {
  static attrNameMapping = { phone2: 'phone2' };

  constructor(sex, birthDate, phone, phone2) {
    super();

    this.sex       = sex;
    this.birthDate = birthDate;
    this.phone     = phone;
    this.phone2    = phone2;
  }

  static deserialize(row) {
    const info = super.deserialize(row);

    if (!_.isNil(row.birth_date))            { info.birthDate          = moment(row.birth_date);            }
    if (!_.isNil(row.birth_date_updated_at)) { info.birthDateUpdatedAt = moment(row.birth_date_updated_at); }

    return info;
  }

  static serialize(info) {
    const row = super.serialize(info);

    if (!_.isNil(info.birthDate))          { row.birth_date            = info.birthDate         .format('YYYY-MM-DD'); }
    if (!_.isNil(info.birthDateUpdatedAt)) { row.birth_date_updated_at = info.birthDateUpdatedAt.format('YYYY-MM-DD'); }

    return row;
  }
}

class Address extends Model {
  constructor(country, city, areaCode, street, houseNumber) {
    super();

    this.country     = country;
    this.city        = city;
    this.areaCode    = areaCode;
    this.street      = street;
    this.houseNumber = houseNumber;
  }
}

class Company extends Model {
  constructor(name, ico, dic) {
    super();

    this.name = name;
    this.ico  = ico;
    this.dic  = dic;
  }
}

class Client extends Model {
  static nominativeName = 'klient';
  static accusativeName = 'klienta';

  static onlyAttrs = [
    'id', 'clientId', 'cardId', 'chipId', 'email', 'firstname', 'surname', 'personal',
    'address', 'company', 'status', 'expirationDate', 'comment', 'news', 'dailyMenu'
  ];

  static null() {
    return new (this)('Null client');
  }

  static deserialize(row) {
    const client = super.deserialize(row);

    const personal = PersonalInfo.deserialize(row.personal ?? {});
    const address  = Address     .deserialize(row.address  ?? {});
    const company  = Company     .deserialize(row.company  ?? {});

    return client.with({ personal, address, company });
  }

  static serialize(client) {
    let address, company, personal;

    if (client.personal) { personal = PersonalInfo.serialize(client.personal); }
    if (client.address)  { address  = Address     .serialize(client.address);  }
    if (client.company)  { company  = Company     .serialize(client.company);  }

    return { ...super.serialize(client), personal, address, company };
  }

  constructor(
    clientId, cardId, email, firstname, surname, personal, address,
    company, status, expirationDate, comment, news, dailyMenu, id
  ) {
    super();

    this.clientId       = clientId;
    this.cardId         = cardId;
    this.email          = email;
    this.firstname      = firstname;
    this.surname        = surname;
    this.personal       = personal;
    this.address        = address;
    this.company        = company;
    this.status         = status;
    this.expirationDate = expirationDate;
    this.comment        = comment;
    this.news           = news;
    this.dailyMenu      = dailyMenu;
    this.id             = id;
  }

  get fullName() {
    return _.compact([this.firstname, this.surname]).join(' ');
  };
}

Client.PersonalInfo = PersonalInfo;
Client.Address      = Address;
Client.Company      = Company;

export default Client;
